angular.module('employeeEdit', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'uiGmapgoogle-maps']);



// WEBPACK FOOTER //
// ./src/app/employee/employee-edit/employee-edit.module.js